"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_AVAILABILITIES_TO_DISPLAY = exports.PROFILE_NAV = exports.USER_ACTION = exports.VIMEO_VIDEO_BASE_URL = exports.SEARCH_INPUT_REVIEW_COUNT = exports.ABOUT_SECTION_EXCLUDE_SUMMARY_DATA_FIELDS = exports.TRACKING_EVENTS = exports.EntityIds = exports.VIRTUAL_VISIT_TYPES = exports.PROFILE_IMAGE_SIZE = exports.PROFILE_IMAGE_WIDTH = exports.PROFILE_BOTTOM_HEIGHT = exports.STATIC_MAP = exports.RATINGS_AND_REVIEWS = exports.DEFAULT_PROFILE_SECTIONS_ORDER = exports.PROFILE_SECTION_IDS = exports.BREAKPOINTS = void 0;
/*
  The Provider Profile design has different breakpoints
  than the `@kyruus/ui-theme` breakpoints.
  Designs and breakpoints: https://kyruus.jira.com/browse/KENG-31924
*/
exports.BREAKPOINTS = {
    small: 632,
    medium: 840,
    large: 992
};
/*
  These values' production definitions are not yet available.
  They are centralized here for now.
  Followup: https://kyruus.jira.com/browse/KENG-32224
*/
exports.PROFILE_SECTION_IDS = {
    PROFILE_TOP: 'profile-top',
    HIGHLIGHTS: 'profile-highlights',
    ABOUT: 'profile-about',
    APPOINTMENTS: 'profile-appointments',
    VIDEOS: 'profile-videos',
    LOCATIONS: 'profile-locations',
    CLINICAL_INTERESTS: 'profile-clinical-interests',
    EXPERTISE: 'profile-expertise',
    INSURANCE_ACCEPTED: 'profile-insurance-accepted',
    REVIEWS: 'profile-reviews',
    // NETWORK_AFFILIATIONS: 'profile-network-affiliations',
    // INFORMATION_CARDS: 'profile-information-cards',
    CARE_TEAM: 'profile-care-team',
    SIMILAR_PROVIDERS: 'profile-similar-providers',
    SCHEDULE_APPOINTMENTS: 'profile-schedule-appointments'
};
exports.DEFAULT_PROFILE_SECTIONS_ORDER = [
    // PROFILE_TOP isn't a customizable section so is excluded here
    exports.PROFILE_SECTION_IDS.SCHEDULE_APPOINTMENTS,
    exports.PROFILE_SECTION_IDS.HIGHLIGHTS,
    exports.PROFILE_SECTION_IDS.ABOUT,
    exports.PROFILE_SECTION_IDS.APPOINTMENTS,
    exports.PROFILE_SECTION_IDS.VIDEOS,
    exports.PROFILE_SECTION_IDS.LOCATIONS,
    exports.PROFILE_SECTION_IDS.CLINICAL_INTERESTS,
    exports.PROFILE_SECTION_IDS.EXPERTISE,
    exports.PROFILE_SECTION_IDS.INSURANCE_ACCEPTED,
    exports.PROFILE_SECTION_IDS.REVIEWS,
    exports.PROFILE_SECTION_IDS.CARE_TEAM,
    exports.PROFILE_SECTION_IDS.SIMILAR_PROVIDERS
];
exports.RATINGS_AND_REVIEWS = {
    SUMMARY_STAR_SIZE_DESKTOP: 17,
    SUBCATEGORY_STAR_SIZE: 14,
    STAR_INNER_MARGIN: 6,
    /* additional width to calibrate the rating value with the filled stars */
    SUMMARY_STARS_ACCURACY_CORRECTION_WIDTH: 5,
    /* additional width to calibrate the rating value with the filled stars */
    SUBCATEGORY_STARS_ACCURACY_CORRECTION_WIDTH: 0
};
exports.STATIC_MAP = {
    small_image_size: '350x200',
    medium_image_size: '600x226',
    large_image_size: '845x226',
    small_map_height: '200px',
    medium_map_height: '226px',
    large_map_height: '226px'
};
// css values
exports.PROFILE_BOTTOM_HEIGHT = '92px';
exports.PROFILE_IMAGE_WIDTH = '128px';
// For image service, the width and height are the same
exports.PROFILE_IMAGE_SIZE = 128;
exports.VIRTUAL_VISIT_TYPES = {
    VIDEO: 'video'
};
exports.EntityIds = {
    ACCESSIBLE: 'ACC0000000002',
    VALET_PARKING: 'ACC0000000003',
    TRANSLATION: 'ACC0000000004',
    AMERICAN_SIGN_LANGUAGE: 'ACC0000000005',
    PARKING: 'ACC0000000006'
};
exports.TRACKING_EVENTS = {
    INSURANCE_DISCLAIMER_LINK_CLICKED: 'user_action.insurance_disclaimer_hyperlink_clicked',
    BOUNDARY_ERROR: 'v9_provider_profile.boundary_error'
};
// these fields are configured in config.provider_v9.summary_data but are not displayed in the About section (they are displayed above in their own sections)
exports.ABOUT_SECTION_EXCLUDE_SUMMARY_DATA_FIELDS = [
    'specialties',
    'network_affiliations',
    'telehealth',
    'age_groups_seen',
    'languages',
    'gender',
    'insurance_accepted',
    'video_url'
];
exports.SEARCH_INPUT_REVIEW_COUNT = 6;
exports.VIMEO_VIDEO_BASE_URL = 'https://player.vimeo.com/video';
exports.USER_ACTION = 'user_action';
exports.PROFILE_NAV = `${exports.USER_ACTION}.provider_detail.nav`;
exports.MAX_AVAILABILITIES_TO_DISPLAY = 6;
//# sourceMappingURL=constants.js.map